// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"7b2dae5f","963":"8c843598","969":"32a1b2ad"}[chunkId] + ".chunk.js";
};